import { TargetingValues } from '../api/openapi_gen/deliveryProviderPortal/deliveryProviderPortal/apis';

export const defaultTargetingParameters: TargetingValues = {
  provider_onboarding: {},
  delivery_provider_portal_flags: {},
};
